import $ from 'jquery';

$(function () {
    if ($('#true_partners_page').length) {
        $('.jv-item').on('click', function (e) {
            $(this).toggleClass('flipped');
        });
    }
});